import { motion, AnimatePresence } from 'framer-motion'
import { 
  Award, 
  Heart, 
  Users, 
  Star, 
  X,
  ChevronLeft,
  ChevronRight,
  Instagram,
  Facebook,
  Youtube
} from 'lucide-react'
import { useState } from 'react'
import { socialMediaConfig } from '../core'
export default function About() {
  // Lightbox state for Gallery of Achievements
  const [selectedImage, setSelectedImage] = useState<typeof galleryImages[0] | null>(null)
  const [currentIndex, setCurrentIndex] = useState(0)

  // Awards and achievements
  // const awards = [
  //   {
  //     icon: <Trophy className="w-8 h-8" />,
  //     title: "South Asia Woman's Achiever Award",
  //     year: "2025",
  //     organization: "TWELL",
  //     description: "For outstanding contribution and excellence in social services."
  //   },
  //   {
  //     icon: <Award className="w-8 h-8" />,
  //     title: "Dancer Doctor",
  //     year: "2025",
  //     organization: "Newspaper",
  //     description: "Recognized for innovative teaching methods and social services."
  //   },
  //   {
  //     icon: <Star className="w-8 h-8" />,
  //     title: "Certificate of Honour",
  //     year: "2024",
  //     organization: "DCPO bangalore",
  //     description: "For her NGO contribution."
  //   }
  //   // {
  //   //   icon: <Heart className="w-8 h-8" />,
  //   //   title: "Digital Innovation in Dance",
  //   //   year: "2021",
  //   //   organization: "Global Dance Network",
  //   //   description: "For pioneering online dance education during the pandemic"
  //   // }
  // ]


  // Media mentions and coverage
  // const mediaMentions = [
  //   {
  //     title: "Dance Therapy: A New Hope for Special Children",
  //     publication: "The Times of India",
  //     date: "March 15, 2023",
  //     excerpt: "Dr. Sophia Mohan's innovative approach to dance therapy has shown remarkable results in helping children with autism and developmental delays..."
  //   },
  //   {
  //     title: "Classical Dance Meets Modern Therapy",
  //     publication: "Hindustan Times",
  //     date: "January 8, 2023",
  //     excerpt: "Dr. Mohan's unique blend of traditional Bharatanatyam with therapeutic techniques is revolutionizing special needs education..."
  //   },
  //   {
  //     title: "Award-Winning Dance Educator Inspires Thousands",
  //     publication: "Delhi Chronicle",
  //     date: "November 22, 2022",
  //     excerpt: "With over 15 years of experience, Dr. Sophia Mohan continues to inspire students of all ages through her passion for dance..."
  //   },
  //   {
  //     title: "Breaking Barriers Through Dance",
  //     publication: "Women's World",
  //     date: "September 10, 2022",
  //     excerpt: "Dr. Mohan's inclusive approach to dance education has made classical dance accessible to students with diverse abilities..."
  //   }
  // ]

  // Gallery images - add your images here
  const galleryImages = [
    {
      src: "/images/gallery/achievements/south-asia-award-2025.jpeg",
      alt: "South Asia Woman's Achiever Award 2025",
      title: "South Asia Woman's Achiever Award",
      subtitle: "2025 • TWELL"
    },
    {
      src: "/images/gallery/achievements/dancer-doctor.jpeg",
      alt: "Dancer Doctor Recognition 2025",
      title: "Dancer Doctor",
      subtitle: "2025 • Newspaper"
    },
    {
      src: "/images/gallery/achievements/project-sahas.jpeg",
      alt: "Certificate of Honour 2024",
      title: "Project Sahas",
      subtitle: "2024 • DCPO Bangalore"
    },
    {
      src: "/images/gallery/achievements/radio-kochi-fm.jpeg",
      alt: "Radio Kochi 90 FM episode",
      title: "Radio Kochi 90 FM",
      subtitle: "2025, Kochi"
    },
    {
      src: "/images/gallery/achievements/manorama-1.2.jpeg",
      alt: "Manorama",
      title: "Dancer Doctor By Raju Bose Life, for Dr. Sophia Mohan",
      subtitle: "2025 • Newspaper"
    },
    {
      src: "/images/gallery/achievements/manorama-2.jpeg",
      alt: "Manorama",
      title: "Sophia Who Realized the Value of Freedom",
      subtitle: "2025 • Newspaper"
    },
    {
      src: "/images/gallery/achievements/darbar-1.jpeg",
      alt: "Newspaper",
      title: "Darbar hall Kochi",
      subtitle: "2025 • Newspaper"
    },
    {
      src: "/images/gallery/achievements/darbar-2.jpeg",
      alt: "Newspaper",
      title: "Darbar hall Kochi - shiv tandav",
      subtitle: "2025 • Newspaper"
    },
    {
      src: "/images/gallery/achievements/maharashtra-newspaper.jpg",
      alt: "Lokmat Times",
      title: "Dilasa Care centre",
      subtitle: "2023 • Newspaper"
    }
  ]

  // Lightbox functions for Gallery of Achievements
  const openLightbox = (image: typeof galleryImages[0], index: number) => {
    setSelectedImage(image)
    setCurrentIndex(index)
  }

  const closeLightbox = () => {
    setSelectedImage(null)
  }

  const nextImage = () => {
    const nextIndex = (currentIndex + 1) % galleryImages.length
    setCurrentIndex(nextIndex)
    setSelectedImage(galleryImages[nextIndex])
  }

  const prevImage = () => {
    const prevIndex = currentIndex === 0 ? galleryImages.length - 1 : currentIndex - 1
    setCurrentIndex(prevIndex)
    setSelectedImage(galleryImages[prevIndex])
  }

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="gradient-bg text-white py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              About <span className="text-yellow-300">Dr. Sophia Mohan</span>
            </h1>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-8">
              A passionate dance educator, therapist, and advocate for inclusive dance education.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Her Story Section */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
                Meet <span className="gradient-text">Dr. Sophia Mohan</span>
              </h2>
              <div className="space-y-4 text-gray-600 dark:text-gray-300">
                <p>
                  Dr. Sophia Mohan's journey in dance began at the age of 3 when she first stepped into the world of Bharatanatyam in her hometown of Kerala. The intricate movements and profound storytelling of classical dance captured her young spirit, and ignited a passion that would weave through every aspect of her life.
                </p>
                <p>
                Born and raised in Kerala with roots in Kochi and Kottayam, Dr. Sophia pursued her graduation in dentistry from Maharashtra University of Health Sciences. Depiste being in this respectable field, her calling for creating positive impact in society never left her heart. She stated volunteering in various NGOs, teaching them and continued to explore classical forms like Mohiniyattam and Kuchipudi while building her medical career. What began as two separate passions soon revealed itself as a unified calling when she discovered the healing power of movement therapy.
                </p>
                <p>
                Dr. Sophia expanded her expertise beyond traditional boundaries, breaking female stereotypes by earning expertise in dance therapy, Zumba instruction, yoga, and counseling psychology. This diverse foundation allowed her to infuse multiple fields in a practice, where understanding human behavior connects with their creative expression, and healing happens through the joy of movement.
                </p>
              </div>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="bg-gradient-to-br from-primary-400 to-secondary-400 rounded-2xl h-[600px] overflow-hidden shadow-2xl relative">
                <div 
                  className="w-full h-full bg-cover bg-center bg-no-repeat"
                  style={{backgroundImage: 'url("/images/about/instructor.png")'}}
                />
                {/* <div className="absolute inset-0 bg-gradient-to-br from-primary-400/20 to-secondary-400/20" /> */}
              </div>
              <div className="absolute -bottom-4 -right-4 bg-yellow-400 text-yellow-900 px-4 py-2 rounded-full font-bold text-sm">
                Expert Instructor
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Dr. Sophia's Continued Story Section */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            viewport={{ once: true }}
              className="relative"
            >
              <div className="bg-gradient-to-br from-purple-400 to-pink-400 rounded-2xl h-[600px] overflow-hidden shadow-2xl relative">
                <div 
                  className="w-full h-full bg-cover bg-center bg-no-repeat"
                  style={{backgroundImage: 'url("/images/about/phoneix-mall-of-asia.jpeg")'}}
                />
                {/* <div className="absolute inset-0 bg-gradient-to-br from-green-400/20 to-teal-400/20" /> */}
              </div>
              
          </motion.div>

              <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
                viewport={{ once: true }}
            >
              
              <div className="space-y-4 text-gray-600 dark:text-gray-300">
                <p>
                Dr. Sophia's pioneering work in inclusive dance and movement based therapy has earned her prestigious recognition across multiple platforms. She was honored with the <b>SIWAA 2025 Excellence in Social Service Award</b> by India's largest women empowerment platform, and acknowledged in the <b>Hindustan Book of Records</b> as a "Globally Exceptional" achiever in therapeutic movement and inclusion.
                </p>
                <p>
                Her community impact has been formally recognized by the <b>District Child Protection Unit, Central Bengaluru</b>, which awarded her a Certificate of Honor for her leadership in Project Sahas at the Government Children's Home for Boys. She has also been a key contributor to <b>Project Vikas</b>, a Government of Karnataka initiative for the visually impaired.
                </p>
                <p>
                Media recognition has followed her inspiring work, with features in leading Malayalam newspapers including Manorama, Mathrubhumi, and Deepika, earning her the beloved title <b>"Dancer Doctor"</b>. She has been an invited guest speaker on Radio Kochi 90 FM, sharing her expertise on health and wellness with thousands of listeners.
                </p>
                <p>
                Through her platform, events and particpations, she has reached over 500 participants across Kerala, Mumbai, and Bangalore, conducting transformative sessions from intimate therapy circles for children with special needs to large community gatherings promoting inclusive wellness.
                </p>
                </div>
              </motion.div>
          </div>
        </div>
      </section>

      {/* Mission Statement and Values Section */}
      <section className="py-20 bg-gray-50 dark:bg-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
              Our <span className="gradient-text">Mission Statement</span>
            </h2>
          </motion.div>

          {/* Centered Quote */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <blockquote className="text-xl italic text-primary-600 dark:text-primary-400 font-medium border-l-4 border-primary-500 pl-6 pr-6 py-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-2xl mx-auto">
              "Movement is medicine. Inclusion is a choice we practice every day."
            </blockquote>
          </motion.div>

          <div className="grid lg:grid-cols-2 gap-12 items-start relative">
            {/* Mission Statement - Left Side */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="space-y-4 text-gray-600 dark:text-gray-300">
                <p>
                At Dance with Dr. Sophie, we believe that dance is so much more than just an art form—it's a powerful tool for healing, self-expression, and building confidence in every single person, no matter who you are or where you come from.
                </p>
                <p>
                Our mission centers on creating inclusive spaces where art becomes therapy, where traditional boundaries simply melt away, and where you can discover your own inner strength through movement. We're committed to breaking stereotypes and showing the world that a doctor can be an artist, that art can truly be medicine, and that real freedom often shows up in the gentlest moments—a hand that opens, a smile that returns, a foot that finds its rhythm.
                </p>
                <p>
                Our approach blends deep compassion with creativity, combining evidence-based therapeutic techniques with beautiful classical dance traditions. We're here to empower women, children with special needs, their caregivers, and communities that deserve to be seen and celebrated. Through our work, we've learned that real healing happens when we're brave enough to move beyond what's expected and step into something beautiful and new.
                </p>
                <p>
                Whether you're just beginning your journey or you've been dancing for years, we're here to meet you exactly where you are and help you discover the magic that movement can bring to your life.
                </p>
              </div>
            </motion.div>

            {/* Divider */}
            <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gray-300 dark:via-gray-600 to-transparent transform -translate-x-1/2"></div>

            {/* Core Values - Right Side */}
            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              
              <div className="space-y-4">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-start space-x-4"
                >
                  <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <Heart className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Inclusivity</h4>
                    <p className="text-gray-600 dark:text-gray-300">
                    Welcoming all individuals regardless of ability, background, or experience level. We create adaptive spaces where everyone can participate meaningfully and discover their unique potential through movement and dance.
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  viewport={{ once: true }}
                  className="flex items-start space-x-4"
                >
                  <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <Star className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Community</h4>
                    <p className="text-gray-600 dark:text-gray-300">
                    Building supportive connections and lasting friendships through shared movement experiences. We foster environments where students, families, and instructors create bonds that extend beyond the studio and enrich lives.
                    </p>
                  </div>
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.3 }}
                  viewport={{ once: true }}
                  className="flex items-start space-x-4"
                >
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <Users className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Excellence</h4>
                    <p className="text-gray-600 dark:text-gray-300">
                    Committed to delivering the highest quality dance education through evidence-based practices, continuous learning, and innovative approaches that honor both traditional techniques and modern therapeutic methods.
                    </p>
                  </div>
                </motion.div>

              <motion.div
                  initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.5 }}
                viewport={{ once: true }}
                  className="flex items-start space-x-4"
              >
                  <div className="w-10 h-10 bg-gradient-to-br from-pink-500 to-rose-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <Award className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">Growth</h4>
                    <p className="text-gray-600 dark:text-gray-300">
                    Supporting every student's personal development and artistic journey at their own pace. We celebrate progress over perfection, nurturing confidence and self-expression while building technical skills and emotional well-being.
                    </p>
                  </div>
                </motion.div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Teaching Philosophy Section */}
      <section className="py-20 bg-white dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
                Her <span className="gradient-text">Teaching Philosophy</span>
              </h2>
              <div className="space-y-4 text-gray-600 dark:text-gray-300">
                <p>
                At Dance with Dr. Sophie, we believe something beautiful: every single person carries within them an incredible capacity for grace, expression, and healing. Our approach is all about meeting you exactly where you are—we see your unique spark of potential, not any limitations you might think you have.
                </p>
                <p>
                "I don't teach dance to people," Dr. Sophie loves to say. "I help people discover the dance that already lives within them." That's exactly how we create our learning spaces—built on acceptance rather than correction, where your smallest victories become our biggest celebrations and profound transformations.
                </p>
                <p>
                We know that healing happens on your own timeline, never ours. Every session follows a gentle, predictable flow that keeps you feeling safe while giving you room to express yourself freely. We love using story-based learning where your movements become magical—like "picking flowers in an enchanted garden" or being "autumn leaves dancing in the wind."
                </p>
                <p>
                We also bring your whole family into this beautiful journey. We teach parents and caregivers to see their children's movements as their own special language, while offering dedicated wellness sessions because we know you need care too. Because at the end of the day, we truly believe that every person—including you—can access their natural capacity for healing and find that joyful connection we're all searching for.
                </p>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              className="relative"
            >
              <div className="bg-gradient-to-br from-purple-400 to-pink-400 rounded-2xl h-[600px] overflow-hidden shadow-2xl relative">
                <div 
                  className="w-full h-full bg-cover bg-center bg-no-repeat"
                  style={{backgroundImage: 'url("/images/about/s4.png")'}}
                />
                {/* <div className="absolute inset-0 bg-gradient-to-br from-purple-400/20 to-pink-400/20" /> */}
                </div>
              </motion.div>
          </div>
        </div>
      </section>

      {/* Media Mentions Section 
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
              Media <span className="gradient-text">Coverage</span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Dr. Sophia Mohan's work has been featured in leading publications and media outlets.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8">
            {mediaMentions.map((mention, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group"
              >
                <div className="bg-white dark:bg-gray-900 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-700 h-full">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-full flex items-center justify-center flex-shrink-0">
                      <Newspaper className="w-6 h-6 text-white" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-3">
                        <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                          {mention.publication}
                        </h3>
                        <span className="text-sm text-gray-500 dark:text-gray-400">
                          {mention.date}
                        </span>
                      </div>
                      <h4 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                        {mention.title}
                      </h4>
                      <p className="text-gray-600 dark:text-gray-300 leading-relaxed">
                        {mention.excerpt}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>*/}

      {/* Awards and Recognition Section 
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
              Awards & <span className="gradient-text">Recognition</span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              Dr. Sophia's contributions to dance education and therapy have been recognized worldwide.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {awards.map((award, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group"
              >
                <div className="bg-white dark:bg-gray-900 rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 dark:border-gray-700 h-full">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-full flex items-center justify-center mx-auto mb-6">
                      <div className="text-white">
                        {award.icon}
                      </div>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                      {award.title}
                    </h3>
                    <p className="text-sm font-semibold text-primary-600 dark:text-primary-300 mb-4 bg-primary-50 dark:bg-primary-700/20 px-4 py-2 rounded-full">
                      {award.year} • {award.organization}
                    </p>
                    <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
                      {award.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>*/}


      {/* Gallery of Achievements Section */}
      <section className="py-20 bg-white dark:bg-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
              Gallery of <span className="gradient-text">Achievements</span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
              A visual showcase of Dr. Sophia's awards, certificates, and media recognition.
            </p>
          </motion.div>

          {/* Image Gallery */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {galleryImages.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group cursor-pointer"
                onClick={() => openLightbox(image, index)}
              >
                <div className="relative overflow-hidden rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 hover:scale-105">
                  <img 
                    src={image.src} 
                    alt={image.alt}
                    className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white font-semibold text-sm mb-1">{image.title}</h3>
                    <p className="text-white/80 text-xs">{image.subtitle}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      

      {/* Social Media Section */}
      <section className="py-20 bg-gray-50 dark:bg-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <h2 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">
              Follow <span className="gradient-text">Dr. Sophia</span>
            </h2>
            <p className="text-lg text-gray-600 dark:text-gray-300 mb-12 max-w-2xl mx-auto">
              Stay connected with Dr. Sophia's latest dance tutorials, behind-the-scenes content, 
              and inspiring stories from her students.
            </p>
            
            <div className="flex justify-center space-x-8">
              {socialMediaConfig.slice(0, 3).map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`group flex flex-col items-center p-6 bg-white dark:bg-gray-900 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 ${social.color}`}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-primary-100 to-secondary-100 dark:from-primary-800 dark:to-secondary-800 rounded-full flex items-center justify-center mb-4 group-hover:from-primary-200 group-hover:to-secondary-200 dark:group-hover:from-primary-700 dark:group-hover:to-secondary-700 transition-all duration-300">
                    {social.icon === 'instagram' ? <Instagram className="w-8 h-8 text-primary-600" /> :
                     social.icon === 'facebook' ? <Facebook className="w-8 h-8 text-primary-600" /> :
                     social.icon === 'youtube' ? <Youtube className="w-8 h-8 text-primary-600" /> :
                     <Instagram className="w-8 h-8 text-primary-600" />}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                    {social.name}
                  </h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
                    {social.icon === 'instagram' ? 'Photos & Stories' :
                     social.icon === 'facebook' ? 'Community & Updates' :
                     social.icon === 'youtube' ? 'Tutorials & Videos' :
                     'Follow for Updates'}
                  </p>
                </motion.a>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="py-20 gradient-bg text-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl font-bold mb-6">Are you still waiting?</h2>
            <p className="text-lg mb-8 opacity-90 max-w-2xl mx-auto">
              Join hundreds of students who have discovered their passion for dance with Dance with Dr. Sophie. 
            </p>
          </motion.div>
        </div>
      </section>

      {/* Lightbox Modal for Gallery of Achievements */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={closeLightbox}
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="relative max-w-4xl max-h-[90vh] w-full"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={closeLightbox}
                className="absolute top-4 right-4 z-10 p-2 bg-black/50 rounded-full text-white hover:bg-black/70 transition-colors"
              >
                <X className="w-6 h-6" />
              </button>

              {/* Navigation Buttons */}
              {galleryImages.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 z-10 p-2 bg-black/50 rounded-full text-white hover:bg-black/70 transition-colors"
                  >
                    <ChevronLeft className="w-6 h-6" />
              </button>
              <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 z-10 p-2 bg-black/50 rounded-full text-white hover:bg-black/70 transition-colors"
              >
                    <ChevronRight className="w-6 h-6" />
              </button>
                </>
              )}

              {/* Image */}
              <img
                src={selectedImage.src}
                alt={selectedImage.alt}
                className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
              />

              {/* Image Info */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-lg">
                <h3 className="text-xl font-semibold text-white mb-2">{selectedImage.title}</h3>
                <p className="text-gray-200 mb-4">{selectedImage.subtitle}</p>
                <div className="flex items-center gap-4">
                  <span className="px-3 py-1 text-sm font-semibold rounded-full bg-primary-500 text-white">
                    Achievement
                  </span>
                </div>
              </div>

              {/* Image Counter */}
              <div className="absolute top-4 left-4 bg-black/50 text-white px-3 py-1 rounded-full text-sm">
                {currentIndex + 1} / {galleryImages.length}
            </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}